import React from 'react';
import FeedbackPage from './FeedbackPage';
import './FeedbackModal.css';

function FeedbackModal({ isOpen, onClose, user, isAdmin }) {
  if (!isOpen) return null;

  return (
    <div className="feedback-modal-overlay" onClick={onClose}>
      <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Feedback</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-content">
          <FeedbackPage 
            user={user}
            isAdmin={isAdmin}
          />
        </div>
      </div>
    </div>
  );
}

export default FeedbackModal;
